import {comment_getCommentsByUser_Api} from 'apis'
import {getId} from 'apis/model/base'
import EmptyHolder from 'components/EmptyHolder'
import getLinkToDetail from 'helpers/getLinkToDetail'
import {formatSimplifyDate} from 'helpers/dateUtils'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext} from 'react'
import {AiOutlineLike} from 'react-icons/ai'
import {Link} from 'react-router-dom'
import EntityList from 'views/AppLocals/EntityList'
import {bindQueryParam} from 'views/AppLocals/functions/routerHelper'
import UserContext from '../UserContext'
import {RiChat3Line, RiQuestionAnswerFill} from "react-icons/ri";
import {Avatar} from "antd";
import {getType} from "../../../../apis/model/base";
import {BiSolidLike} from "react-icons/bi";
import classNames from "classnames";
import {GoDotFill} from "react-icons/go";

const CommentItem = ({item}) => {
    const t = useTranslate()
    if (!item) return null
    const containerTitle = _.get(item, 'container.title')

    return (
        <div className="p-3 flex flex-col gap-1 background shadow-sm rounded-xl">
            {containerTitle && (
                <div className="space-x-1 font-medium max-lines-3 leading-snug">
                    <span className="text-slate-500">{`${t('commented on')} ${t(getType(item?.container))}: `}</span>
                    <Link
                        to={getLinkToDetail(item.container)}
                        className="text-gray-900 hover:text-secondary-600 no-underline">
                        {containerTitle}
                    </Link>
                </div>
            )}
            <div className="flex items-center gap-3">
                <span className="text-xs text-color-300 italic tracking-wide">
                    <GoDotFill size={10} className="mr-0.5 text-slate-400"/>
                    {formatSimplifyDate(item.created, 'fullTime')}
                </span>
                {item.total_votes > 0 && (
                    <span className="flex items-center gap-1 ">
                        <Avatar
                            size={20}
                            icon={<BiSolidLike size={10} className="text-white"/>}
                            style={{border: '2px solid #fff'}}
                            className={classNames('flex flex-center', 'bg-blue-600')}
                        />
                        <span className="font-medium text-xs text-gray-700 tracking-wide leading-snug">
                            {item.total_votes}
                        </span>
                    </span>
                )}
            </div>
            <div style={{ borderRadius: '0 1rem 1rem' }} className="mt-1 px-3 py-2 bg-slate-50 text-sm text-gray-700 leading-snug break-words whitespace-pre-line">
                {item.message}
            </div>
        </div>
    )
}

const UserComments = ({Wrapper = 'div'}) => {
    const {user} = useContext(UserContext)
    const id = getId(user)

    if (!id) return null

    return (
        <Wrapper className="flex flex-col">
            <EntityList
                apiInfo={comment_getCommentsByUser_Api}
                query={bindQueryParam({id})}
                renderItem={(item, index) => <CommentItem item={item} key={index}/>}
                RenderEntity={React.Fragment}
                renderEmpty={() => (
                    <div className="w-full flex justify-center items-center">
                        <EmptyHolder/>
                    </div>
                )}
                renderWrap={(child) => (
                    <div className="flex flex-col gap-3">
                        {child}
                    </div>
                )}
            />
        </Wrapper>
    )
}

export default UserComments
